import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { DocumentTitle } from '../components';
import { Sider } from './Sider/Sider';
const { Content } = Layout;
export const SiderLayout = () => (_jsxs(Layout, { style: { flexDirection: 'row' }, children: [_jsx(DocumentTitle, {}), _jsx(Sider, { layoutHeight: "100vh" }), _jsx(Layout, { children: _jsx(Content, { style: { overflow: 'auto' }, children: _jsx(Outlet, {}) }) })] }));
